



















import gsap from "gsap";

export default {
  name: "Home",
  mounted: function() {
    //
    gsap
      .timeline()
      .fromTo(
        "section",
        { opacity: 0, y: -50 },
        { opacity: 1, y: 0, duration: 1 }
      );
  }
};
